import type { FeatureTagSchema } from 'src/models/featureTag/schema';
import type { LOCALE_TYPE } from 'src/types/locale';
import { BackendApiFetch } from 'src/utils/backendApi';
import { errorMessage } from 'src/utils/errorMessage';

export const fetchFeatureTags = async (locale: string, isStaticProps = false): Promise<FeatureTagSchema[]> => {
  try {
    const response = await BackendApiFetch<FeatureTagSchema[]>({
      path: '/app/v1/feature_tags',
      localeType: locale,
      isStaticProps
    });
    if (response.statusCode === 200) {
      return response.data;
    }
    return [];
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export const fetchFilteredFeatureTags = async (
  locale: LOCALE_TYPE,
  isStaticProps = false
): Promise<FeatureTagSchema[]> => {
  try {
    const response = await BackendApiFetch<FeatureTagSchema[]>({
      path: '/api/v1/feature_tags',
      localeType: locale,
      isStaticProps
    });
    return response.data;
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};
